import React from 'react'
import { ReactElement, useEffect } from 'react'
import { RouteNamesExternal } from 'constants/routeNamesExternal'

const NotFound = (): ReactElement => {
  useEffect(() => {
    window.location.assign(RouteNamesExternal.ATD_404)
  }, [])
  return <></>
}

export default NotFound
